import { createContext, useContext, useState, ReactNode } from "react";

interface BookingModalContextType {
  isAnyModalOpen: boolean;
  setIsAnyModalOpen: (open: boolean) => void;
}

const BookingModalContext = createContext<BookingModalContextType | undefined>(undefined);

export const BookingModalProvider = ({ children }: { children: ReactNode }) => {
  const [isAnyModalOpen, setIsAnyModalOpen] = useState(false);

  return (
    <BookingModalContext.Provider value={{ isAnyModalOpen, setIsAnyModalOpen }}>
      {children}
    </BookingModalContext.Provider>
  );
};

export const useBookingModal = () => {
  const context = useContext(BookingModalContext);
  if (!context) {
    throw new Error("useBookingModal must be used within a BookingModalProvider");
  }
  return context;
};
